import { render, staticRenderFns } from "./StatusMaterial.vue?vue&type=template&id=55016c17&scoped=true"
import script from "./StatusMaterial.vue?vue&type=script&lang=js"
export * from "./StatusMaterial.vue?vue&type=script&lang=js"
import style0 from "./StatusMaterial.vue?vue&type=style&index=0&id=55016c17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55016c17",
  null
  
)

export default component.exports